import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		user: JSON.parse(window.localStorage.getItem('userInfo')),
		submit_order_rarams: JSON.parse(sessionStorage.getItem('submit_order_rarams')),
		common_info: "",
		qycg_submit_order_rarams: JSON.parse(sessionStorage.getItem('qycg_submit_order_rarams')),
		qycg_user: JSON.parse(window.localStorage.getItem('qycgUserInfo')),
		orderId: JSON.parse(window.localStorage.getItem('orderDetailsId')),
		all_express_price: "",
		route_url: JSON.parse(window.localStorage.getItem('routeUrl')),
		qycg_title: window.localStorage.getItem('qycgTitle'),
		// qycg_title: JSON.parse(window.localStorage.getItem('qycgTitle')),
	},
	mutations: {
		// 用户信息
		userInfo(state, data) {
			state.user = data;
			window.localStorage.setItem('userInfo', JSON.stringify(state.user))
		},
		// 支付
		submitOrderRarams(state, data) {
			state.submit_order_rarams = data;
			window.sessionStorage.setItem('submit_order_rarams', JSON.stringify(data));
		},
		// 头尾公共信息
		commonInfo(state, data) {
			state.common_info = data;
		},
		// 企业采购 -> 支付
		qycgSubmitOrderRarams(state, data) {
			state.qycg_submit_order_rarams = data;
			window.sessionStorage.setItem('qycg_submit_order_rarams', JSON.stringify(data));
		},
		// 企业采购 -> 用户信息
		qycgUserInfo(state, data) {
			state.qycg_user = data;
			window.localStorage.setItem('qycgUserInfo', JSON.stringify(state.qycg_user))
		},
		//订单id
		orderDetailsId(state, data) {
			state.orderId = data;
			window.localStorage.setItem('orderDetailsId', JSON.stringify(state.orderId))
		},
		//订单总运费
		allExpressPrice(state, data) {
			state.all_express_price = data;
		},
		//企业路由
		routeUrl(state, data) {
			state.route_url = data;
			window.localStorage.setItem('routeUrl', JSON.stringify(state.route_url))
		},
		//企业title
		qycgTitle(state, data) {
			state.qycg_title = data;
			window.localStorage.setItem('qycgTitle', state.qycg_title)
		},
	},
	actions: {},
	modules: {}
})
